import * as React from 'react';
import styled from 'styled-components';

import Flex from '@components/layout/flex';
import DatepickerPriceItem from './datepicker-price-item';
import { CalendarTiers } from '@webapp/sdk/plans';

interface DatepickerPricesProps {
  className?: string;
  priceTiers: CalendarTiers['priceTiers'];
  selected?: string;
}

const DatepickerPrices: React.FC<DatepickerPricesProps> = (props) => {
  return (
    <Flex flexWrap="wrap" className={`${props.className} mt-30`}>
      {props.priceTiers?.map((tier) => (
        <DatepickerPriceItem
          key={tier.name}
          className={`datepicker-price-item ${
            props.selected && tier.name !== props.selected ? 'not-selected' : ''
          }`}
          type={tier.name}
          price={tier.price}
          isSelected={tier.name === props.selected}
        />
      ))}
    </Flex>
  );
};

export default styled(DatepickerPrices)`
  .datepicker-price-item {
    margin: 2px 5px;

    //&:last-child {
    //  margin-right: 0;
    //}

    &.not-selected {
      opacity: 0.25;
    }
  }
`;
